import { useEffect } from "react";

import { useBreakpoint } from "use-breakpoint";

import { bubbleLoaderStyle } from "@/components/style";
import { BREAKPOINTS } from "@/constants/defaultValue";
import { useDynamicViewportHeight } from "@/hooks/useViewportPolyfill";
import { cn } from "@/lib/utils";
import useChatStore from "@/stores/useChatStore";
import useGlobalStore from "@/stores/useGlobalStore";

import Header from "@/modules/chat-app/components/Header";
import Nav from "@/modules/chat-app/components/Nav";
import FooterContent from "./Footer";
import Reminder from "./Remider";

function ReminderDetail() {
  const { breakpoint } = useBreakpoint(BREAKPOINTS);
  const footerHeight = useChatStore((state) => state.footerHeight);
  const isMobile = ["xs", "sm"].includes(breakpoint);
  const dynamicViewportHeight = useDynamicViewportHeight();

  useEffect(() => {
    if (isMobile) {
      useGlobalStore.setState({ navVisible: false });
    }
  }, [breakpoint, isMobile]);

  // Sử dụng height tự động cho mobile khi keyboard xuất hiện
  const containerHeight = isMobile ? "100dvh" : `${dynamicViewportHeight}px`;
  const reminderHeight = isMobile
    ? "calc(100dvh - 85px)" // Để browser tự động tính toán với dvh
    : `${dynamicViewportHeight - (footerHeight + 110)}px`;

  return (
    <div className={cn("flex flex-col overflow-hidden bg-[#F6F8FC] pb-[env(safe-area-inset-bottom)]", isMobile ? "mobile-viewport" : "")} style={!isMobile ? { height: containerHeight } : {}}>
      <style>{bubbleLoaderStyle}</style>
      <div className="flex flex-1 overflow-hidden">
        <Nav />
        <div className="w-full flex flex-col">
          <Header isBack={true} title={"Thông tin tổng hợp"} />

          <div className="flex flex-row flex-1 overflow-hidden">
            <div className={cn("transition-all duration-300 ease-in-out flex flex-col", "w-full")}>
              <div
                className="mx-auto overflow-auto flex-1 overscroll-contain w-full"
                style={{
                  maxHeight: isMobile ? "calc(100dvh - 140px)" : reminderHeight,
                  background: "radial-gradient(200% 200% at 50% 50%, rgb(194 225 255 / 34%) 0%, rgba(230, 246, 244, 0) 20%)",
                }}
              >
                <Reminder />
              </div>
              <div className={cn("flex-shrink-0", isMobile && "sticky bottom-0 bg-[#F6F8FC] pt-2 keyboard-adjust")}>
                <FooterContent
                  isPopupContent={isMobile}
                  isMobile={isMobile}
                  className={"max-w-[820px] mx-auto px-4"}
                  inputClassName={cn("border-none shadow-[0_2px_8px_rgba(0,0,0,0.1)] focus-visible:ring-0 focus-visible:ring-offset-0", isMobile ? "pr-10" : "h-16 pl-5 pr-14")}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderDetail;
